var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOprovided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#E4E4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#E6EBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.75C21.22 32.75 20.46 32.35 19.94 31.65L18.93 30.3C18.72 30.02 18.44 29.86 18.14 29.84C17.84 29.83 17.54 29.96 17.3 30.21L16.73 29.7L17.28 30.21C15.84 31.75 14.73 31.63 14.2 31.42C13.66 31.21 12.75 30.52 12.75 28.3V17.04C12.75 12.6 14.03 11.25 18.22 11.25H25.78C29.97 11.25 31.25 12.6 31.25 17.04V28.3C31.25 30.51 30.34 31.2 29.8 31.42C29.27 31.63 28.17 31.75 26.72 30.21C26.48 29.95 26.19 29.81 25.87 29.84C25.57 29.86 25.28 30.02 25.07 30.3L24.06 31.65C23.54 32.35 22.78 32.75 22 32.75ZM18.08 28.33C18.12 28.33 18.17 28.33 18.21 28.33C18.95 28.37 19.65 28.76 20.12 29.39L21.13 30.74C21.62 31.39 22.37 31.39 22.86 30.74L23.87 29.39C24.35 28.76 25.04 28.37 25.79 28.33C26.53 28.29 27.27 28.6 27.81 29.18C28.57 29.99 29.07 30.09 29.24 30.02C29.48 29.92 29.74 29.34 29.74 28.3V17.04C29.74 13.43 29.11 12.75 25.77 12.75H18.22C14.88 12.75 14.25 13.43 14.25 17.04V28.3C14.25 29.35 14.51 29.93 14.75 30.02C14.92 30.09 15.42 29.99 16.18 29.18C16.72 28.63 17.39 28.33 18.08 28.33Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17.75H18C17.59 17.75 17.25 17.41 17.25 17C17.25 16.59 17.59 16.25 18 16.25H26C26.41 16.25 26.75 16.59 26.75 17C26.75 17.41 26.41 17.75 26 17.75Z",
    fill: "#8280FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.75H19C18.59 21.75 18.25 21.41 18.25 21C18.25 20.59 18.59 20.25 19 20.25H25C25.41 20.25 25.75 20.59 25.75 21C25.75 21.41 25.41 21.75 25 21.75Z",
    fill: "#8280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOprovided);
export default __webpack_public_path__ + "static/media/oprovided.82712ceb20afc56bf392e7bf742bc446.svg";
export { ForwardRef as ReactComponent };